package com.eladfinish.bible.contest.ui.components

/**
 * A native object the page in a [WebView] can call from JavaScript, attached when the WebView is
 * created, before the page loads, and detached when it leaves the screen. Each platform's bridge
 * knows its own view type (`android.webkit.WebView`, `WKWebView`); [attach] gets it as [Any]
 * because common code has no WebView type.
 */
interface WebViewBridge {

    fun attach(webView: Any)

    fun detach()
}

/** One [WebViewBridge] for several (a [WebView] takes one): null when none is given. */
fun webViewBridgeOf(vararg bridges: WebViewBridge?): WebViewBridge? {
    val present = bridges.filterNotNull()
    return when (present.size) {
        0 -> null
        1 -> present.single()
        else -> CompositeWebViewBridge(present)
    }
}

private class CompositeWebViewBridge(private val bridges: List<WebViewBridge>) : WebViewBridge {

    override fun attach(webView: Any) = bridges.forEach { it.attach(webView) }

    override fun detach() = bridges.forEach { it.detach() }
}
